import {StyleSheet} from 'react-native';

export default StyleSheet.create({
    container: {
        backgroundColor:'#ffffff',
        flex:1
    },
    input: {
        backgroundColor:'#eeeeee',
        height: 40,
        marginHorizontal: 12,
        padding: 7,
        marginTop:12,
        color:"#bbbbbb",
        fontFamily: 'Raleway',
        fontSize: 16
    },
    searchContainer:{
        marginHorizontal:'5%',
        marginTop:-30,
        height:70,
        backgroundColor:'#ffffff',
        borderWidth:2,
        borderStyle:"solid",
        borderColor:"#eeeeee",
        borderRadius:7
    },
    categoryContainer:{
        marginVertical:25,
        marginLeft:'8%',
        marginRight:'8%'
    },
    iconFull: {
        width: 40,
        height: 40,
        borderRadius: 20,
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        bottom: 30,
        right: 15,
        padding:15
    },
    shareText:{
        color:'#fff',
        fontSize:10,
        fontFamily: 'Raleway',
    },
    loading:{
        alignSelf:'center',
        fontSize:16,
        fontFamily: 'Raleway',
    },
    fab:{
        position: 'absolute',
        margin: 16,
        right: 0,
        bottom: 0,
    }
});